export function getFirstName(name) {
  return name.split(' ')[0].toLowerCase()
}

export function formatZipCode(zipcode) {
  return zipcode.replace('.', '')
}